export default __webpack_public_path__ + "static/media/MLBFantasyPWRSBanner.83e4ad91.png";